import { useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children into a container at the end of <body> (`#portal-root` by default).
 * `containerId` / `containerClassName` give a family of overlays its own shared container,
 * e.g. so several floating task widgets stack instead of covering each other.
 */
export default function Portal({ children, containerId = 'portal-root', containerClassName }) {
  const [container] = useState(() => {
    let el = document.getElementById(containerId);
    if (!el) {
      el = document.createElement('div');
      el.id = containerId;
      if (containerClassName) el.className = containerClassName;
      document.body.appendChild(el);
    }
    return el;
  });

  return createPortal(children, container);
}
